<template>
  <div class="searchMainWrpr container">
    <div class="row justify-content-between">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3">
        <div class="select my-1" style="display: none">
          <select
            name="format"
            :value="type"
            @input="$emit('update:type', $event.target.value)"
          >
            <option value="">ALL ACTIVITIES</option>
            <option value="ride">Ride</option>
            <option value="workout">Workout</option>
            <option value="event">Event</option>
          </select>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3">
        <div class="select my-1 float-end">
          <select
            name="format"
            :value="sortDate"
            @input="$emit('update:sortDate', $event.target.value)"
          >
            <option value="DESC">SORT BY DATE DESC</option>
            <option value="ASC">SORT BY DATE ASC</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityFilters",
  props: {
    type: {
      type: String,
      default: "",
    },
    sortDate: {
      type: String,
      default: "DESC",
    },
  },
  emits: ["update:type", "update:sortDate"],
};
</script>

<style scoped>
.searchMainWrpr {
  margin-top: 8px;
}
</style>
